import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "components/ui";
import useDarkMode from "utils/hooks/useDarkMode";
import { themeConfig } from "configs/theme.config";

const DEFAULT_COLOR = '#3b82f6';

const Theme = (props) => {
  const customPrimaryColor = useSelector((state) => state.theme.customPrimaryColor);
  const themeState = useSelector((state) => state.theme);
  const [isDark] = useDarkMode();
  const [mounted, setMounted] = useState(false);

  console.log('Theme render - customPrimaryColor:', customPrimaryColor);

  // Wait for mount to avoid hydration issues
  useEffect(() => {
    setMounted(true);
  }, []);

  // Set custom theme color as CSS variable
  useEffect(() => {
    if (!mounted) return;

    const root = document.documentElement;
    const colorToUse = customPrimaryColor || DEFAULT_COLOR;

    root.style.setProperty('--theme-primary', colorToUse);

    // Generate light version
    const hex = colorToUse.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    root.style.setProperty('--theme-primary-light', `rgba(${r}, ${g}, ${b}, 0.1)`);

    console.log('Setting color to:', colorToUse);

  }, [customPrimaryColor, mounted]);

  const currentTheme = {
    mode: isDark ? "dark" : "light",
    ...themeConfig,
    ...themeState,
  };

  return (
    <>
      <ConfigProvider value={currentTheme}>{props.children}</ConfigProvider>
    </>
  );
};

export default Theme;
